export default __webpack_public_path__ + "static/media/memberIcon.95284829.png";